<template>
    <div class="custom-page">
        <div class="block center">
            <div v-for="news in newsList"
                class="news-item"
                :key="news.newsId"
                @click="goDetail(news)"
            >
                <div class="date-area">
                    <h6>{{news.day}}</h6>
                    <p>{{news.month}}</p>
                </div>
                <div class="content-area">
                    <h6>{{isCn ? news.titleChina : news.titleEng}}</h6>
                    <p>{{isCn ? news.cnBriefIntro : news.enBriefIntro}} <small v-text="'》'"></small></p>
                </div>
                <div class="img-area">
                    <img :src="news.image" alt="">
                </div>
            </div>
        </div>
        <div class="page-block">
            <Pagination :page="page" :totalPage="totalPage" @pageChange="pageChange"></Pagination>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import Pagination from '@/components/list/Pagination.vue';
import ajax from '@/utils/ajax';
import { gDate } from '@/utils/format';
import router from '@/router';

export default {
    name: 'customListBlock',
    components: {
        Layout,
        Pagination,
    },
    props: {
        pageId: Number,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            isMore: false,
            page: 1,
            totalPage: 1,
            newsList: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        goDetail(news) {
            router.push({ name: 'newsDetail', params: { id: news.newsId } });
        },
        getList() {
            const params = {
                pageSize: 10,
                page: this.page,
            };
            if (this.$props.pageId) {
                params.newsTypeId = this.$props.pageId;
            }
            ajax.get('/web/news/news_list.json', {
                ...params,
            }).then((result) => {
                this.newsList = result.dataList.map((v) => {
                    v.day = gDate.datetimeFormat(v.pubTime, 'DD');
                    v.month = gDate.datetimeFormat(v.pubTime, 'YYYY-MM');
                    v.cnBriefIntro = v.cnBriefIntro.length > 100 ? `${v.cnBriefIntro.substr(0, 100)} ...` : v.cnBriefIntro;
                    v.enBriefIntro = v.cnBriefIntro.length > 200 ? `${v.cnBriefIntro.substr(0, 200)} ...` : v.enBriefIntro;
                    return v;
                });
                this.page = result.page;
                this.totalPage = result.totalPage;
            }).catch(() => {});
        },
        pageChange(page) {
            this.page = page;
            this.getList();
        },
    },
};
</script>
<style lang="less" scoped>
    .block {
        margin-top: 10px;
        background: #fff;
        padding: 15px 0;
        .block-title {
            display: block;
            padding-top: 8px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
        }
        .block-title-line {
            margin-top: 6px;
            display: block;
            margin: 0 auto;
            width: 22px;
            height: 2px;
            background: #C71F4B;
        }
    }
    .center {
        width: 960px;
        margin: 0 auto;
    }
    .news-item {
        padding: 20px 0;
        border-bottom: 1px solid #F1F1F1;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        .date-area {
            flex: 0 0 100px;
            min-width: 100px;
            max-width: 100px;
            height: 72px;
            background: #D1D3D1;
            color: #fff;
            margin-right: 20px;
            h6 {
                padding-top: 4px;
                font-size: 36px;
                text-align: center;
                line-height: 40px;
            }
            p {
                font-size: 16px;
                text-align: center;
                line-height: 24px;
            }
        }
        .content-area {
            flex: 0 0 595px;
            max-width: 595px;
            min-width: 595px;
            margin-right: 22px;
            h6 {
                font-size :16px;
                font-weight: 600;
                line-height: 32px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            p {
                display: -webkit-box;
                height: 36px;
                line-height: 18px;
                font-size: 12px;
                word-break: break-word;
                color: #9B9B9B;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
        .img-area {
            flex: 0 0 224px;
            min-width: 224px;
            max-width: 224px;
            height: 120px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        &:hover {
            .date-area {
                background: #C71F4B;
            }
            .content-area h6 {
                color: #C71F4B;
            }
            .content-area small {
                color: #C71F4B;
            }
        }
    }
    .page-block {
        padding: 16px 0 24px;
    }
</style>
